import React, { useEffect } from 'react';
import TabPageContainer from '~components/atoms/TabPageContainer';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';
import CollateralApprovalTableSearchAndFilterBar from './CollateralApprovalTableSearchAndFilterBar';
import CollateralApprovalTable from './CollateralApprovalTable';
import CollateralApprovalTablePaginator from './CollateralApprovalTablePaginator';
import ConfirmUpdateCollateralStatusModal from './ConfirmUpdateCollateralStatusModal';

const CollateralApproval = () => {
    const dispatch = useAppDispatch();

    const collateralListingIndex = useAppSelector(state => state.approval.pendingCollateralListing.index);

    useEffect(() => {
        dispatch(combinedActions.approvalGetPendingCollateralListingAttempt());
    }, [collateralListingIndex]);

    return (
        <TabPageContainer>
            <CollateralApprovalTableSearchAndFilterBar/>

            <CollateralApprovalTable />

            <CollateralApprovalTablePaginator />

            <ConfirmUpdateCollateralStatusModal />
        </TabPageContainer>
    );
};

export default CollateralApproval;
